import * as React from 'react';

import { State } from '~/store/types';
import connect from '~/store/connect';
import { ResidentConfigurationForm } from './ResidentConfigFormContainer';
import { ResidentConfigDetail } from './ResidentConfigDetail';
import { Spinner } from '@ixicare/ui';
import { t } from '~i18n';
import { useStores } from '~store/utils';

interface ResidentSettingsContainerProps {
  profile: State['residentDetail']['profile'];
  adminPermissions?: boolean;
}

const ResidentSettingsContainer: React.FC<ResidentSettingsContainerProps> = ({ profile }) => {
  const { permissions } = useStores();
  if (!permissions.loaded) {
    return <Spinner label={t('global.loading')} />;
  }
  const configurationPermission = permissions.has('can_edit_all_profiles');
  return (
    <>
      {profile && configurationPermission ? (
        <ResidentConfigurationForm profile={profile} />
      ) : (
        profile && <ResidentConfigDetail profile={profile} />
      )}
    </>
  );
};

export default connect((state: State) => ({
  profile: state.residentDetail.profile,
}))(ResidentSettingsContainer);
